/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentEventSeverities } from './equipment-event-severities';


export interface SearchEquipmentEventHistoryResponse { 
    id: string;
    equipmentId: string;
    modelName: string;
    macAddress: string;
    categoryName: string;
    severity: EquipmentEventSeverities;
    workerName: string;
    isUnknownWorker: boolean;
    ipAddress: string;
    description: string;
    createdDate: string;
}



